import Part from "@/components/body/parts/part";
import Utils, { LevelRange } from "@/components/shared/util";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import SVG from "svg.js";

const ettId = "#endoTube";
const trachId = "#trach";
export default class Ett extends Part {
  ettPath!: SVG.Element;
  trachPath!: SVG.Element;

  getExtraData(patient: Patient): any {
    let trach = false;
    const intersection = _.intersection(patient.body.risk, [
      "Tracheostomy",
      "Stoma"
    ]);
    if (intersection.length) {
      trach = true;
    }
    this.extraData = { trach };
  }

  updateData(patient: Patient | null) {
    super.updateData(patient);
    if (!this.ettPath) {
      this.ettPath = SVG.select(ettId, this.container.node).first();
    }
    if (!this.trachPath) {
      this.trachPath = SVG.select(trachId, this.container.node).first();
      this.trachPath.hide();
    }

    let level: LevelRange = this.globalConfig.useOrange
      ? this.atom.level
      : this.atom.level === 6
      ? 0
      : this.atom.level;
    let pathToStroke;
    if (this.extraData.trach) {
      pathToStroke = this.trachPath;
      this.trachPath.show();
      this.ettPath.hide();
    } else {
      pathToStroke = this.ettPath;
      this.ettPath.show();
      this.trachPath.hide();
    }
    pathToStroke.stroke(Utils.getLevelColor(level, this.showGreenGrayOnly));
  }
}
